import React from "react";

import PermissionsContext from "./permissions-context";

export const usePermissions = () => {
  const context = React.useContext(PermissionsContext);

  if (context === undefined) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }

  return context;
};

// Helper hook para verificar permissão específica
export const useHasPermission = (permissionCode: string): boolean => {
  const { hasPermission } = usePermissions();
  return hasPermission(permissionCode);
};

// Helper hook para verificar múltiplas permissões (qualquer uma)
export const useHasAnyPermission = (permissionCodes: string[]): boolean => {
  const { hasAnyPermission } = usePermissions();
  return hasAnyPermission(permissionCodes);
};

// Helper hook para verificar múltiplas permissões (todas)
export const useHasAllPermissions = (permissionCodes: string[]): boolean => {
  const { hasAllPermissions } = usePermissions();
  return hasAllPermissions(permissionCodes);
};

